import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-pruefen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksAufgabePruefenEffects {

    AufgabePruefen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_PRUEFEN),
        mergeMap((x: ac.PostAufgabePruefenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabePruefen(x.prueflaufAufgabeAntwortRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabePruefenErfolgreichAction(result, x.prueflaufAufgabeAntwortRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabePruefenFehlerAction(error, x.prueflaufAufgabeAntwortRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufCommandService);
        }
        return this.service;
    }
}
